import React from 'react';

import { NavbarPrimary, NavbarSecondary } from '../templates/sections';
import { Flex } from '../common';
import { GatsbyImage } from 'gatsby-plugin-image';

const Header = (props) => {
  const { page, sanity } = props;
  const { navbars } = sanity;
  return (
    <header id="header" className="fixed top-0 z-50 w-full shadow-lg">
      <NavbarSecondary page={page} sanity={sanity} />
      <NavbarPrimary page={page} sanity={sanity} />
      <Flex classes="flex-row lg:hidden justify-center text-center bg-blue-950 text-white">
        <Flex classes="gap-x-3">
          <div className="relative">
            <GatsbyImage
              image={navbars?.navOfferIcon?.asset?.gatsbyImageData}
              alt={navbars?.navOfferIcon?.alt}
              className="h-auto w-4 object-cover !align-middle mb-1"
            />
          </div>
          <div className="relative">
            <span className="text-base text-white italic">
              {navbars?.navOfferLabel}
            </span>
          </div>
        </Flex>
      </Flex>
    </header>
  );
};

export { Header };
